import {Inject, Injectable, makeStateKey, Optional, PLATFORM_ID, TransferState} from "@angular/core";
import {REQUEST} from "../../tokens/request.token";
import {isPlatformServer} from "@angular/common";
import {createLogger} from "../../shared/helpers/logger/logger";

const GEO_KEY = makeStateKey<string>('country_code');

const logger = createLogger('GeoService');

@Injectable({
    providedIn: 'root'
})
export class GeoService {
    constructor(
        private transferState: TransferState,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Optional() @Inject(REQUEST) private request: any
    ) {
    }

    initialize() {
        if (isPlatformServer(this.platformId)) {
            if (this.request && this.request.countryCode) {
                this.transferState.set(GEO_KEY, this.request.countryCode);
            } else {
                logger.warn('[GeoService] No countryCode in request, skipping TransferState');
            }
        } else {
            logger.info('[GeoService] Running on client, skipping initialization');
        }
    }

    getCountryCode(): string {
        if (isPlatformServer(this.platformId) && this.request) {
            return this.request.countryCode || 'default';
        } else {
            const fromTransferState = this.transferState.get(GEO_KEY, null);
            if (fromTransferState) {
                return fromTransferState;
            }
            if (typeof window !== 'undefined') {
                return this.getCountryFromBrowser() || 'default';
            }
            return 'default';
        }
    }

    private getCountryFromBrowser(): string {
        return 'IN'; // Mock value for testing
    }
}
